var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgE648F99B268782F39Ea1442529369Aa3555555(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "afcae5a789ccd549f9c6e2a2f80dbd76"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#555555"
    },
    d: "M256,0.5C114.893,0.5,0.5,114.893,0.5,256S114.893,511.5,256,511.5 S511.5,397.107,511.5,256S397.107,0.5,256,0.5z M347.084,316.977l-30.107,30.107l-60.224-60.22l-60.22,60.22l-30.112-30.111 l60.22-60.22l-61.725-61.729l30.112-30.108l61.725,61.725l60.224-60.22l30.107,30.112l-60.22,60.219L347.084,316.977z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE648F99B268782F39Ea1442529369Aa3555555);
export default __webpack_public_path__ + "static/media/e648f99b268782f39ea1442529369aa3_555555.0ed5d70e256fa260f09456cab630373a.svg";
export { ForwardRef as ReactComponent };